import { For } from "solid-js";

import { Skeleton } from "@/components/ui/skeleton";

interface ContentSkeletonProps {
  rows?: number;
}

const DEFAULT_ROWS = 6;

/**
 * Granular placeholder for the main content region (the route <Outlet />) shown
 * while the PowerSync local DB is still initializing. Mirrors the coarse shape
 * of a data view — a header/toolbar row plus a list of rows — so the shell can
 * mount instantly without the content area flashing empty.
 */
export function ContentSkeleton(props: ContentSkeletonProps) {
  const rows = () => props.rows ?? DEFAULT_ROWS;

  return (
    <div class="flex flex-1 flex-col gap-4 p-4 sm:p-6" aria-hidden="true">
      {/* Header / toolbar */}
      <div class="flex items-center justify-between gap-4">
        <Skeleton class="h-8 w-40" />
        <Skeleton class="h-9 w-28" />
      </div>

      {/* Rows */}
      <div class="flex flex-col gap-3">
        <For each={Array.from({ length: rows() })}>
          {() => (
            <div class="flex items-center gap-3 rounded-lg border border-border/40 p-3">
              <Skeleton class="h-10 w-10 shrink-0 rounded-md" />
              <div class="flex flex-1 flex-col gap-2">
                <Skeleton class="h-4 w-1/3" />
                <Skeleton class="h-3 w-1/2" />
              </div>
            </div>
          )}
        </For>
      </div>
    </div>
  );
}
